// extracted by mini-css-extract-plugin
export var formContainer = "_md-0";
export var message = "_md-1";